// extracted by mini-css-extract-plugin
export default {"hideTooltip":"J9-z","fadeIn":"K9-z","delay":"L9-z","recommendedSizeTooltip":"M9-z"};